webpackJsonp([0],{

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// -----------------------------------
// Tween search
// -----------------------------------

function tweenComparator(a, b, time) {
  if (a.stop <= time && time < b.stop) {
    return 0;
  } else {
    if (time < a.stop) {
      return -1;
    } else {
      return 1;
    }
  }
}

function tweenSearch(sortedList, time, low, high, comparator) {
  var mid = Math.floor(low + (high - low) / 2);
  var len = sortedList.length;

  if (len == 0) return null;
  if (mid < 0) return [sortedList[0]];
  if (mid == len - 1) return [sortedList[len - 1]];

  var a = sortedList[mid];
  var b = sortedList[mid + 1];

  var result = comparator(a, b, time);

  if (result == 0) {
    return [a, b];
  } else {
    if (result < 0) {
      return tweenSearch(sortedList, time, low, mid - 1, comparator);
    } else {
      return tweenSearch(sortedList, time, mid + 1, high, comparator);
    }
  }
}

// -----------------------------------
// Keyframe interpolation
// -----------------------------------

function timingToInterpFn(timing, lib) {
  var map = {
    'linear': lib.linearInterpolate,
    'smooth': lib.smoothInterpolate
  };
  return map[timing] || map.linear;
}

function _keyframeInterpolate(keyframes, time, timing, lib) {

  if (!Array.isArray(keyframes) || !keyframes.length) {
    return lib.zero();
  }

  var result = search.tween(keyframes, time);
  var interpolate = timingToInterpFn(timing, lib);

  if (result.length == 1) {
    var value = result[0].value;
    return interpolate(value, value, 0);
  }

  var _result = _slicedToArray(result, 2),
      a = _result[0],
      b = _result[1];

  var t_segment = (time - a.stop) / (b.stop - a.stop);
  return interpolate(a.value, b.value, t_segment);
}

// -------------------------------------------------
// search library
// -------------------------------------------------

var search = {

  /**
   * Find the keyframe or keyframe pair closest to a given time
   * @param {keyframe[]} sortedList a list of keyframes sorted
   * by 'stop', e.g, [{stop: 0.1}, {stop: 0.3}, {stop: 0.5}]
   * @param {number} time the time nearest to the desired keyframe
   * or keyframe pair
   * @param {function} comparator the search comparator function, e.g.,
   * (candidate:keyframe, target:keyframe) => number
   */
  tween: function tween(sortedList, time) {
    var comparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : tweenComparator;

    return tweenSearch(sortedList, time, 0, sortedList.length - 1, comparator);
  }
};

// -------------------------------------------------
// util library
// -------------------------------------------------

var util = {

  /**
   * Smooth a parameter in the range 0 <= t <= 1 in a manner
   * that approximates cosine.
   * @param {float} t interpolation parameter in the range [0, 1]
   * @returns {float}
   */
  smooth: function smooth(t) {
    return 3 * Math.pow(t, 2) - 2 * Math.pow(t, 3);
  },


  /**
   * Convert a 3d byte vector to a hex color string,
   * e.g, [0, 127, 255] -> #007fff
   * @param {number[]} vector a three-element array
   * @returns {string}
   */
  vector3dToHex: function vector3dToHex(vector) {
    var hexColor = '#' + vector.slice(0, 3).map(function (c) {
      var byte = Math.round(c);
      var hex = byte.toString(16);
      return hex.length == 1 ? '0' + hex : hex;
    }).join('');

    return hexColor;
  },


  /**
   * Convert a hex color string to a 3d byte vector,
   * e.g, #007fff -> [0, 127, 255]
   * @param {string} hexColor
   * @returns {number[]}
   */
  hexToVector3d: function hexToVector3d(hexColor) {
    var hex = hexColor.slice(1);
    var r = parseInt(hex.slice(0, 2), 16);
    var g = parseInt(hex.slice(2, 4), 16);
    var b = parseInt(hex.slice(4, 6), 16);
    return [r, g, b];
  },


  /**
   * Convert a 3d byte vector to an rgb color string,
   * e.g., [0, 127, 255] -> 'rgb(0,127,255)'
   * @param {number[]}
   * @returns {string}
   */
  vector3dToRgb: function vector3dToRgb(vector) {
    vector = vector.slice(0, 3).map(function (byte) {
      return Math.round(byte);
    });
    return 'rgb(' + vector + ')';
  },


  /**
   * Convert an rgb color string to a 3d byte vector,
   * e.g., 'rgb(0,127,255)' -> [0, 127, 255]
   * @param {string} rgbColor
   * @returns {number[]}
   */
  rgbToVector3d: function rgbToVector3d(rgbColor) {
    var list = rgbColor.split(/[(), ]+/);
    return list.slice(1, 4).map(function (s) {
      return +s;
    });
  },


  /**
   * Sort a list of keyframes in place, or any list of objects
   * with a numerical 'stop' property
   * @param {keyframe[]} keyframes a list of keyframes in
   * the form, e.g.,  [{stop: 0.5}, {stop: 0.1}, {stop: 0.95}]
   * @returns {keyframe[]}
   */
  keyframeSort: function keyframeSort(keyframes) {
    return keyframes.sort(function (a, b) {
      return a.stop - b.stop;
    });
  }
};

// -------------------------------------------------
// scalar library
// -------------------------------------------------

var scalar = {

  /**
   * Return zero
   * @returns {number}
   */
  zero: function zero() {
    return 0;
  },


  /**
   * Interpolate between a and b for a factor of t
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  linearInterpolate: function linearInterpolate(a, b, t) {
    return a + t * (b - a);
  },


  /**
   * Interpolate between a and b for a factor of t
   * with a smooth, ease in, ease out type effect
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  smoothInterpolate: function smoothInterpolate(a, b, t) {
    return a + util.smooth(t) * (b - a);
  },


  /**
   * Interpolate with keyframes, e.g.,
   * [{stop: 0.1, value: 10}, {stop: 0.5, value: 20}, {stop: 0.9, value: 30}]
   * @param {keyframe[]} keyframes a list of keyframes
   * @param {number} time the time nearest the keyframe stop
   * @param {'linear'|'smooth'} timing interpolation timing
   * @param {object} lib the interpolation library to use
   */
  keyframeInterpolate: function keyframeInterpolate(keyframes, time) {
    var timing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'linear';
    var lib = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : scalar;

    return _keyframeInterpolate(keyframes, time, timing, lib);
  }
};

// -------------------------------------------------
// vector2d library
// -------------------------------------------------

var vector2d = {

  /**
   * Return the zero vector
   */
  zero: function zero() {
    return [0, 0];
  },


  /**
   * Interpolate between vectors a and b for a factor of t
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  linearInterpolate: function linearInterpolate(a, b, t) {
    var lerp = scalar.linearInterpolate;
    return [lerp(a[0], b[0], t), lerp(a[1], b[1], t)];
  },


  /**
   * Interpolate between vectors a and b for a factor of t
   * with a smooth, ease in, ease out type effect
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  smoothInterpolate: function smoothInterpolate(a, b, t) {
    var lerp = scalar.smoothInterpolate;
    return [lerp(a[0], b[0], t), lerp(a[1], b[1], t)];
  },


  /**
   * Interpolate with keyframes, e.g.,
   * [
   *   {stop: 0.1, value: [0, 100]},
   *   {stop: 0.5, value: [100, 100]},
   *   {stop: 0.9, value: [100, 0]}
   * ]
   * @param {keyframe[]} keyframes a list of keyframes
   * @param {number} time the time nearest the keyframe stop
   * @param {'linear'|'smooth'} timing interpolation timing
   * @param {object} lib the interpolation library to use
   */
  keyframeInterpolate: function keyframeInterpolate(keyframes, time) {
    var timing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'linear';
    var lib = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : vector2d;

    return _keyframeInterpolate(keyframes, time, timing, lib);
  }
};

// -------------------------------------------------
// vector3d library
// -------------------------------------------------

var vector3d = {

  /**
   * Return the zero vector
   */
  zero: function zero() {
    return [0, 0, 0];
  },


  /**
   * Interpolate between vectors a and b for a factor of t
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  linearInterpolate: function linearInterpolate(a, b, t) {
    var lerp = scalar.linearInterpolate;
    return [lerp(a[0], b[0], t), lerp(a[1], b[1], t), lerp(a[2], b[2], t)];
  },


  /**
   * Interpolate between vectors a and b for a factor of t
   * with a smooth, ease in, ease out type effect
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  smoothInterpolate: function smoothInterpolate(a, b, t) {
    var lerp = scalar.smoothInterpolate;
    return [lerp(a[0], b[0], t), lerp(a[1], b[1], t), lerp(a[2], b[2], t)];
  },


  /**
   * Interpolate with keyframes, e.g.,
   * [
   *   {stop: 0.1, value: [0, 100]},
   *   {stop: 0.5, value: [100, 100]},
   *   {stop: 0.9, value: [100, 0]}
   * ]
   * @param {keyframe[]} keyframes a list of keyframes
   * @param {number} time the time nearest the keyframe stop
   * @param {'linear'|'smooth'} timing interpolation timing
   * @param {object} lib the interpolation library to use
   */
  keyframeInterpolate: function keyframeInterpolate(keyframes, time) {
    var timing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'linear';
    var lib = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : vector3d;

    return _keyframeInterpolate(keyframes, time, timing, lib);
  }
};

exports.util = util;
exports.search = search;
exports.scalar = scalar;
exports.vector2d = vector2d;
exports.vector3d = vector3d;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _keyframesList = __webpack_require__(89);

var _keyframesList2 = _interopRequireDefault(_keyframesList);

var _colorControl = __webpack_require__(87);

var _colorControl2 = _interopRequireDefault(_colorControl);

var _vectorKeyframes = __webpack_require__(52);

__webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function spaceKeysEvenly(keyframes) {
  var len = keyframes.length;

  if (len === 1) {
    keyframes[0].stop = 0;
  } else if (len > 1) {
    for (var i = 0; i < len; ++i) {
      keyframes[i].stop = +(i / (len - 1)).toFixed(3);
    }
  }
  return keyframes;
}

function performInterpolation(keyframes, t, timing) {
  var vector = _vectorKeyframes.vector3d.keyframeInterpolate(keyframes, t, timing);
  return _vectorKeyframes.util.vector3dToHex(vector);
}

var KeyframeInterpolation = function (_React$Component) {
  _inherits(KeyframeInterpolation, _React$Component);

  function KeyframeInterpolation(props) {
    _classCallCheck(this, KeyframeInterpolation);

    var _this = _possibleConstructorReturn(this, (KeyframeInterpolation.__proto__ || Object.getPrototypeOf(KeyframeInterpolation)).call(this, props));

    var timing = 'smooth';
    var sliderValue = 0.5;
    var keyframes = spaceKeysEvenly(props.keyframes);
    var color = performInterpolation(keyframes, sliderValue, timing);

    _this.state = { keyframes: keyframes, sliderValue: sliderValue, color: color, timing: timing };
    return _this;
  }

  _createClass(KeyframeInterpolation, [{
    key: 'onAddKeyframe',
    value: function onAddKeyframe() {
      var keyframes = this.state.keyframes.slice(0);
      var len = keyframes.length;
      var vector = len && keyframes[len - 1].vector || [127, 127, 127];

      keyframes.push({
        stop: 0.0,
        value: vector
      });
      spaceKeysEvenly(keyframes);

      var color = performInterpolation(keyframes, this.state.sliderValue, this.state.timing);
      this.props.onChangeKeyframes(keyframes);
      this.setState({ keyframes: keyframes, color: color });
    }
  }, {
    key: 'onDeleteKeyframe',
    value: function onDeleteKeyframe(index) {
      var keyframes = this.state.keyframes.slice(0);
      keyframes.splice(index, 1);
      spaceKeysEvenly(keyframes);
      var color = performInterpolation(keyframes, this.state.sliderValue, this.state.timing);
      this.props.onChangeKeyframes(keyframes);
      this.setState({ keyframes: keyframes, color: color });
    }
  }, {
    key: 'onChangeStop',
    value: function onChangeStop(index, e) {
      var keyframes = this.state.keyframes.slice(0);
      var keyframe = keyframes[index];
      keyframe.stop = Math.min(Math.max(e.target.value, 0), 1);
      var color = performInterpolation(keyframes, this.state.sliderValue, this.state.timing);
      this.props.onChangeKeyframes(keyframes);
      this.setState({ keyframes: keyframes, color: color });
    }
  }, {
    key: 'onChangeColor',
    value: function onChangeColor(index, e) {
      var keyframes = this.state.keyframes.slice(0);
      var keyframe = keyframes[index];
      keyframe.vector = _vectorKeyframes.util.hexToVector3d(e.target.value);
      var color = performInterpolation(keyframes, this.state.sliderValue, this.state.timing);
      this.props.onChangeKeyframes(keyframes);
      this.setState({ keyframes: keyframes, color: color });
    }
  }, {
    key: 'onChangeSlider',
    value: function onChangeSlider(e) {
      var sliderValue = e.target.value;
      var color = performInterpolation(this.state.keyframes, sliderValue, this.state.timing);
      this.setState({ sliderValue: sliderValue, color: color });
    }
  }, {
    key: 'onChangeTiming',
    value: function onChangeTiming(e) {
      var timing = e.target.value;
      var color = performInterpolation(this.state.keyframes, this.state.sliderValue, timing);
      this.setState({ timing: timing, color: color });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'KeyframeInterpolation' },
        _react2.default.createElement(_colorControl2.default, {
          color: this.state.color,
          value: this.state.sliderValue,
          selected: this.state.timing,
          onChangeTiming: this.onChangeTiming.bind(this),
          onChangeSlider: this.onChangeSlider.bind(this) }),
        _react2.default.createElement(
          'h2',
          null,
          'Keyframes'
        ),
        _react2.default.createElement(_keyframesList2.default, { keyframes: this.state.keyframes,
          onChangeStop: this.onChangeStop.bind(this),
          onChangeColor: this.onChangeColor.bind(this),
          onDeleteKeyframe: this.onDeleteKeyframe.bind(this) }),
        _react2.default.createElement(
          'div',
          { className: 'button-wrapper' },
          _react2.default.createElement(
            'button',
            { onClick: this.onAddKeyframe.bind(this) },
            'Add Keyframe'
          )
        )
      );
    }
  }]);

  return KeyframeInterpolation;
}(_react2.default.Component);

exports.default = KeyframeInterpolation;

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _keyframeInterpolation = __webpack_require__(83);

var _keyframeInterpolation2 = _interopRequireDefault(_keyframeInterpolation);

__webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var initial_keyframes = [{ stop: 0.0, value: [0, 0, 255] }, { stop: 0.0, value: [0, 255, 0] }, { stop: 0.0, value: [255, 0, 0] }];

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.state = { keyframes: initial_keyframes };
    return _this;
  }

  _createClass(App, [{
    key: 'onChangeKeyframes',
    value: function onChangeKeyframes(keyframes) {
      this.setState({ keyframes: keyframes });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h1',
          null,
          'Keyframe Interpolation'
        ),
        _react2.default.createElement(_keyframeInterpolation2.default, {
          keyframes: this.state.keyframes,
          onChangeKeyframes: this.onChangeKeyframes.bind(this) }),
        _react2.default.createElement(
          'pre',
          { className: 'json' },
          JSON.stringify(this.state.keyframes, null, 2)
        )
      );
    }
  }]);

  return App;
}(_react2.default.Component);

_reactDom2.default.render(_react2.default.createElement(App, null), document.getElementById('root'));

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ColorControl;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _vectorKeyframes = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ColorControl(props) {
  var style = { backgroundColor: props.color };

  return _react2.default.createElement(
    'div',
    { className: 'ColorControl' },
    _react2.default.createElement('div', { className: 'color-chip', style: style }),
    _react2.default.createElement('input', { type: 'range', min: '0', max: '1', step: '0.001',
      value: props.value,
      onChange: props.onChangeSlider }),
    _react2.default.createElement(
      'div',
      { className: 'color-text' },
      props.color,
      ',\xA0',
      'rgb(' + _vectorKeyframes.util.hexToVector3d(props.color).toString() + ')'
    ),
    _react2.default.createElement(
      'div',
      { className: 'timing' },
      _react2.default.createElement(
        'label',
        null,
        'Smooth',
        _react2.default.createElement('input', { type: 'radio', value: 'smooth',
          onChange: props.onChangeTiming,
          checked: props.selected === 'smooth' })
      ),
      _react2.default.createElement(
        'label',
        null,
        'Linear',
        _react2.default.createElement('input', { type: 'radio', value: 'linear',
          onChange: props.onChangeTiming,
          checked: props.selected === 'linear' })
      )
    )
  );
}

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Keyframe;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Keyframe(props) {
  return _react2.default.createElement(
    "li",
    { className: "Keyframe" },
    _react2.default.createElement(
      "label",
      { className: "stop" },
      _react2.default.createElement(
        "span",
        null,
        "stop:"
      ),
      _react2.default.createElement("input", { type: "number", step: "0.01",
        value: props.stop,
        onChange: props.onChangeStop })
    ),
    _react2.default.createElement(
      "label",
      { className: "color" },
      _react2.default.createElement(
        "span",
        null,
        "color:"
      ),
      _react2.default.createElement("input", { type: "color",
        value: props.color,
        onChange: props.onChangeColor })
    ),
    _react2.default.createElement(
      "button",
      { className: "delete",
        onClick: props.onDeleteKeyframe },
      "x"
    )
  );
}

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _keyframe = __webpack_require__(88);

var _keyframe2 = _interopRequireDefault(_keyframe);

var _vectorKeyframes = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KeyframesList = function (_React$Component) {
  _inherits(KeyframesList, _React$Component);

  function KeyframesList(props) {
    _classCallCheck(this, KeyframesList);

    return _possibleConstructorReturn(this, (KeyframesList.__proto__ || Object.getPrototypeOf(KeyframesList)).call(this, props));
  }

  _createClass(KeyframesList, [{
    key: 'onChangeStop',
    value: function onChangeStop(index, event) {
      this.props.onChangeStop(index, event);
    }
  }, {
    key: 'onChangeColor',
    value: function onChangeColor(index, event) {
      this.props.onChangeColor(index, event);
    }
  }, {
    key: 'onDeleteKeyframe',
    value: function onDeleteKeyframe(index, event) {
      this.props.onDeleteKeyframe(index, event);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'ul',
        { className: 'KeyframesList' },
        ' ',
        this.props.keyframes.map(function (keyframe, index) {
          return _react2.default.createElement(_keyframe2.default, { key: index,
            stop: keyframe.stop,
            color: _vectorKeyframes.util.vector3dToHex(keyframe.value),
            onChangeStop: _this2.onChangeStop.bind(_this2, index),
            onChangeColor: _this2.onChangeColor.bind(_this2, index),
            onDeleteKeyframe: _this2.onDeleteKeyframe.bind(_this2, index) });
        })
      );
    }
  }]);

  return KeyframesList;
}(_react2.default.Component);

exports.default = KeyframesList;

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[86]);


// WEBPACK FOOTER //
// app.0da56e3db7f116593b7c.js